/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_tip_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the US, 18–20% has become the typical range for good table service, with 15% now considered on the low end. Tipping conventions vary by country and situation — delivery, bars, and buffets often use different expectations — so treat these as general starting points rather than fixed rules.`)
};

const es_pct_tip_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En EE. UU., el 18–20% se ha convertido en el rango habitual para un buen servicio de mesa, y el 15% ahora se considera en el extremo bajo. Las costumbres de propina varían según el país y la situación — repartos a domicilio, bares y bufés suelen tener expectativas distintas — así que trátalos como puntos de partida generales y no como reglas fijas.`)
};

const de_pct_tip_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In den USA sind 18–20% mittlerweile die übliche Spanne für guten Service am Tisch, 15% gelten inzwischen als eher niedrig. Trinkgeldgepflogenheiten variieren je nach Land und Situation — bei Lieferdiensten, Bars und Buffets gelten oft andere Erwartungen — betrachte diese Werte also eher als allgemeine Richtwerte denn als feste Regeln.`)
};

const nl_pct_tip_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In de VS is 18–20% het gebruikelijke bereik geworden voor goede bediening aan tafel, waarbij 15% tegenwoordig als aan de lage kant wordt beschouwd. Fooigewoonten verschillen per land en situatie — bezorging, bars en buffetten kennen vaak andere verwachtingen — beschouw dit dus als algemene richtlijnen en niet als vaste regels.`)
};

const fr_pct_tip_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aux États-Unis, 18 à 20 % est devenu la fourchette habituelle pour un bon service en salle, 15 % étant désormais considéré comme le minimum. Les usages en matière de pourboire varient selon le pays et la situation — livraison, bars et buffets ont souvent des attentes différentes — considérez donc ces chiffres comme des repères généraux plutôt que des règles fixes.`)
};

const it_pct_tip_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negli Stati Uniti, il 18–20% è diventato l'intervallo tipico per un buon servizio al tavolo, con il 15% ormai considerato al limite basso. Le convenzioni sulle mance variano per paese e situazione — consegne, bar e buffet spesso hanno aspettative diverse — quindi considera questi come punti di partenza generali e non regole fisse.`)
};

const pt_br2_pct_tip_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nos EUA, 18–20% se tornou a faixa típica para um bom atendimento à mesa, com 15% agora considerado no limite inferior. As convenções de gorjeta variam por país e situação — entregas, bares e buffets costumam ter expectativas diferentes — então trate isso como pontos de partida gerais, não como regras fixas.`)
};

const pt_pct_tip_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nos EUA, 18–20% tornou-se o intervalo típico para um bom serviço de mesa, sendo os 15% agora considerados no limite inferior. As convenções de gorjeta variam por país e situação — entregas, bares e bufetes têm muitas vezes expectativas diferentes — por isso trate estes valores como pontos de partida gerais e não como regras fixas.`)
};

const ja_pct_tip_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アメリカでは、良いテーブルサービスに対しては18〜20%が一般的な範囲となっており、15%は今では低めとみなされます。チップの慣習は国や状況によって異なり、デリバリー、バー、ビュッフェなどではまた別の基準が使われることが多いため、これらはあくまで一般的な目安として捉え、固定のルールとは考えないでください。`)
};

const zh_pct_tip_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在美国，18–20% 已成为优质堂食服务的常见范围，15% 如今被视为偏低。小费惯例因国家和场合而异——外卖、酒吧和自助餐往往有不同的预期——所以请把这些当作一般参考，而不是固定规则。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_tip_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_tip_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_tip_faq4_a", locale)
	if (locale === "en") return en_pct_tip_faq4_a(inputs)
	if (locale === "es") return es_pct_tip_faq4_a(inputs)
	if (locale === "de") return de_pct_tip_faq4_a(inputs)
	if (locale === "nl") return nl_pct_tip_faq4_a(inputs)
	if (locale === "fr") return fr_pct_tip_faq4_a(inputs)
	if (locale === "it") return it_pct_tip_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_tip_faq4_a(inputs)
	if (locale === "pt") return pt_pct_tip_faq4_a(inputs)
	if (locale === "ja") return ja_pct_tip_faq4_a(inputs)
	return zh_pct_tip_faq4_a(inputs)
};